import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { ApiService } from './api.service';
import { Subject } from 'rxjs';

export class HubNotification {
    TYPE_NOTIFICATION: string;
    NOTIFICATION_DATAS: any;
    TYPE_DATAS: any;
    SHOW_NOTIFICATION: boolean;
    MESSAGE?: string;
}

@Injectable({
    providedIn: 'root'
})
export class SignalRService {
    connection: signalR.HubConnection;
    notificationHub$ = new Subject<HubNotification>();

    constructor(
        private _apiService: ApiService,
    ) {
    }

    doConnectHub(): Promise<void> {
        const buildedUrl = `${this._apiService.baseEndpointUrl}/workspacehub`;
        this.connection = new signalR.HubConnectionBuilder() 
          .withAutomaticReconnect()
          .configureLogging(signalR.LogLevel.None)
          .withUrl(buildedUrl)
          .build();
        this._handleEvents();
        return this.connection.start();
    }

    disconnect(): void {
      this.connection.stop();
    }

    isConnected(): boolean {
        return !!this.connection && this.connection.state == signalR.HubConnectionState.Connected;
    }

    async authenticate(accessToken: string) {
        if (!!this.connection) {
          if (!this.isConnected()) {
            await this.doConnectHub();
          }
          this.connection.invoke('AuthenticateUser', accessToken);
        }
    }

    unauthenticate(): void {
        if (!!this.connection) {
          this.connection.invoke('DisconnectUser');
        }
    }

    private _handleEvents() {
        this.connection.on('NOTIFICATION', (notification: HubNotification) => {
            if (notification.SHOW_NOTIFICATION === true) {
                this.launchWebNotification(notification);
            }
            if (notification.TYPE_NOTIFICATION === 'RUNNER_REMDOCS_CONNECTED') {
              console.log('Runner connecté', notification.NOTIFICATION_DATAS);
            }
            if (notification.TYPE_NOTIFICATION === 'RUNNER_REMDOCS_DISCONNECTED') {
              console.log('Runner déconnecté', notification.NOTIFICATION_DATAS);
            }
            if (notification.TYPE_NOTIFICATION === 'CASHDESK_SYNC_UPDATE') {
              console.log('Sync caisse', notification.NOTIFICATION_DATAS);
            }
            this.notificationHub$.next(notification);
        });
    }

    private launchWebNotification(notification: HubNotification) {
        if(! ('Notification' in window) ){
            console.log('Web Notification not supported');
            return;
        }

        Notification.requestPermission((permission) => {
            new Notification("Cauris Linkup",{body:notification.MESSAGE, dir:'auto'});
        });
    }
}
